;(function module() {
  angular
    .module('app.ui.form.ctrls')
    .controller('PositionDetailsController', function controller(
      position,
      listingName,
      PositionApi
    ) {
      var vm = this
      vm.position = position
      const setPositionRecord = async id => {
        const {data} = await PositionApi.getPositionById(id)
        vm.position.employer.name = data.employer.name
        vm.position.description = data.description
        vm.position.locations = data.locations
        vm.position.specialtiesName =
          data.specialties.length > 0
            ? data.specialties.map(specialty => specialty.name)
            : []
        vm.position.employerType = vm.position.employer.type
          ? typeof vm.position.employer.type === 'string'
            ? vm.position.employer.type
            : vm.position.employer.type.join()
          : ''
        vm.position.specialtiesName = [...new Set(vm.position.specialtiesName)]
        vm.position.externalUrlLink = vm.position.externalUrl
          ? vm.position.externalUrl.match(/http/)
            ? vm.position.externalUrl
            : 'http://'.concat(vm.position.externalUrl)
          : vm.position.externalUrl
        vm.position.employer.picSrc = data.employer.logo
          ? `${process.env.PUBLIC_BUCKET_URL}/employers/${data.employerId}/logo/${data.employer.logo}`
          : `/images/firmlogo_Default.png`
      }

      setPositionRecord(vm.position.id, vm)
    })
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/position-details/position-details.ctrl.js